<template>
  <v-bottom-navigation 
    color="#fff" 
    fixed 
    active-class="bottomActive"
    v-model="value"
  >
    <v-btn value="home" to="home">
      <v-icon>mdi-home</v-icon>
    </v-btn>

    <v-btn value="calendar" to="calendar">
      <v-badge
        :content="notification"
        :value="notification"
        color="red"
        overlap
      >
        <v-icon>mdi-calendar</v-icon>
      </v-badge>
    </v-btn>

    <v-btn value="history" to="history">
      <v-icon>mdi-chart-timeline-variant-shimmer</v-icon>
    </v-btn>

    <v-btn value="config" to="config">
      <v-icon>mdi-dots-horizontal</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>
<script>
export default {
  data() {
    return {
      value: undefined,
    };
  },
  computed: {
    notification() {
      return this.$store.getters.notification;
    },
  },
};
</script>
<style lang="scss">
.bottomActive{
  border-radius: 0 !important;
  background-color: #FFB5CC !important;
}
.v-item-group.v-bottom-navigation .v-btn{
  max-width: 100% !important;
  width: 100%;
}
.theme--light.v-bottom-navigation{
  .v-btn:not(.v-btn--active){
    color: #999 !important;
  }
} 
</style>